import React from 'react';
import useStyles from './style';
import { AlertTitle, Alert } from '@mui/material';
import { DialogTitle, Dialog, DialogContent, DialogActions, Button, TextField, LinearProgress, Typography } from '@mui/material';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { sendPlanToEmailAction } from '../actions/apartments_action';
import { sendQuestionAction } from '../actions/apartments_action';

const SendToEmailDialog = ({ open, setOpen, apartmentId, buildingName, levelNumber }) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [email, setEmail] = React.useState('');
    const [question, setQuestion] = React.useState('');

    const sendQuestionSelector = useSelector(state => state.sendQuestionState);
    const { loading, sendQuestion } = sendQuestionSelector;

    const handleClose = () => {
        setOpen(false);
    };

    const handleSendQuestion = (e) => {
        e.preventDefault();
        dispatch(sendQuestionAction({
            email,
            question,
            apartmentId,
            buildingName,
            levelNumber
        }));
    };

    const ShowLoading = () => {
        return (
            <div>
                <Typography variant='caption'>Slanje...</Typography>
                <LinearProgress color='primary' />
            </div>
        )
    };

    const ShowError = () => {
        return (
            <div style={{ marginBottom: '10px' }}>
                <Alert severity="error">
                    <AlertTitle>Greška</AlertTitle>
                    Neuspješno slanje
                </Alert>
            </div>
        )
    };

    const ShowSuccess = () => {
        return (
            <div style={{ marginBottom: '10px' }}>
                <Alert severity="success">
                    <AlertTitle>Uspješno</AlertTitle>
                    Pitanje poslato
                </Alert>
            </div>
        )
    };

    return (
        <Dialog
            maxWidth='sm'
            fullWidth
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>
                Posaljite pitanje
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSendQuestion} style={{ padding: '5px' }}>
                    {
                        typeof sendQuestion !== 'undefined'
                            ?
                            sendQuestion.success
                                ?
                                <ShowSuccess />
                                :
                                <ShowError />
                            :
                            null
                    }
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={12}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                required
                                label="Unesite vas email"
                                name="email"
                                type="email"
                                value={email}
                                onChange={(e) => { setEmail(e.target.value); }}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                required
                                label="Pitanje"
                                name="question"
                                type="text"
                                multiline
                                minRows={6}
                                maxRows={8}
                                value={question}
                                onChange={(e) => { setQuestion(e.target.value); }}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            {
                                loading
                                    ?
                                    <ShowLoading />
                                    :
                                    <Button type='submit' variant='contained' color='success' >
                                        Posalji
                                    </Button>
                            }
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color='error'>
                    Zatvori
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default SendToEmailDialog;